<div kbOnVisible [rootMargin]="'50px'" (visibilityChange)="onVisibilityChange($event)" class="">
    <div class="h-2"></div>
    <div
        *ngIf="!showRelatedTags || (showRelatedTags && tagIds?.length)"
        class="relative pt-8 pb-12 px-4 sm:px-6 lg:pb-28"
    >
        <div class="relative max-w-7xl mx-auto">
            <div class="text-left">
                <kb-section-header>{{ title }}</kb-section-header>
            </div>
            <div class="mt-10 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
                <div
                    *ngFor="let post of topPosts$ | async"
                    class="flex flex-col rounded shadow-lg overflow-hidden"
                >
                    <div class="flex-shrink-0">
                        <img class="h-48 w-full object-cover" loading='lazy' [src]="post.imageUrl" alt="Blog post thumbnail" />
                    </div>
                    <div class="flex-1 bg-white p-6 flex flex-col justify-between">
                        <div class="flex-1">
                            <p class="text-xs font-medium text-primary-500 flex flex-wrap" *ngIf="includeCategoryLinks">
                                <a
                                    *ngFor="let category of post.categories"
                                    [href]="category.link"
                                    target="_blank"
                                    class="border-primary-100 bg-primary-50 px-2 py-0.5 rounded mr-2 mb-2"
                                >
                                    {{ category.name }}
                                </a>
                            </p>
                            <a [href]="post.link" target="_blank" class="block mt-2">
                                <p class="text-xl font-semibold text-gray-900" [innerHTML]="post.title"></p>
                                <p class="mt-3 text-base text-gray-500" [innerHTML]="post.text"></p>
                            </a>
                        </div>
                        <div class="mt-6 flex items-center">
                            <a class='btn btn-primary' [href]="post.link">Read more</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
